module.exports = __webpack_public_path__ + "static/media/dice.196a15fb.svg";